import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { API_URL } from "../../../utils/constant";
import CompanyCurrencyModal from "./company_currency_modal";
import { Pen, Trash } from "lucide-react";
import { customTableStyles } from "../../../utils/tableStylings";

const CompanyCurrency = () => {
    const [currencies, setCurrencies] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchCurrencies = async () => {
        try {
            setLoading(true);
            const company_id = localStorage.getItem("companyID");
            const res = await axios.get(`${API_URL}/company-currencies`);
            setCurrencies(res.data.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCurrencies();
    }, []);

    const handleAdd = () => {
        setEditData(null);
        setShowModal(true);
    };

    const handleEdit = (row) => {
        setEditData(row);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This will delete the currency!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirm.isConfirmed) return;

        try {
            await axios.delete(`${API_URL}/company-currencies/${id}`);
            Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Currency deleted successfully",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
            fetchCurrencies();
        } catch {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to delete currency",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });
        }
    };

    const columns = [
        {
            name: "Currency",
            selector: (row) => row.currency,
            sortable: true,
            cell: (row) => (
                <div>
                    <span>{row.currency}</span>
                    {row.is_default === 1 && (
                        <span className="badge bg-success ms-2">
                            Default
                        </span>
                    )}
                </div>
            ),
        },
        { name: "Conversion Rate", selector: (row) => row.conversion_rate, sortable: true },
        { name: "Symbol", selector: (row) => row.symbol, sortable: true },
        { name: "Position", selector: (row) => row.position, sortable: true },
        { name: "Decimal Format", selector: (row) => row.decimal_format, sortable: true },
        // {
        //     name: "Actions",
        //     cell: (row) => (
        //         <>
        //             <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(row)}>
        //                 <Pen />
        //             </button>
        //             <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id)}>
        //                 <Trash />
        //             </button>
        //         </>
        //     ),
        //     ignoreRowClick: true,
        //     button: true,
        // },
    ];

    return (
        <>
            <div className="row" style={{ marginTop: "60px" }}>
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="text-primary mb-0">Currencies</h3>
                            {/* <button className="btn btn-primary" onClick={handleAdd}>
                                + Add Currency
                            </button> */}
                        </div>

                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={currencies}
                                progressPending={loading}
                                pagination
                                highlightOnHover
                                responsive
                                customStyles={customTableStyles}
                            />
                        </div>

                        {showModal && (
                            <CompanyCurrencyModal
                                show={showModal}
                                heading={editData ? "Edit Currency" : "Add Currency"}
                                initialData={editData}
                                onClose={() => setShowModal(false)}
                                onSuccess={fetchCurrencies}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyCurrency;
